import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public showLoader$ = new BehaviorSubject<boolean>(false);
  public showWaitingMessage$ = new BehaviorSubject<string>(null);
  constructor() { }

  public showLoader() {
    this.showLoader$.next(true);
  }

  public hideLoader() {
    this.showLoader$.next(false);
  }
}
